import styled from "styled-components"
import { useLocale, useT } from "react-polyglot-hooks"
import * as PropTypes from "prop-types"
import Typography from "../../styled/Typography"
import Item from "./Item"

const List = styled.ul`
  padding: 0;
  margin: 0 -25px -15px 0;
`

export default function ServicesList({ car }) {
  const t = useT()
  const locale = useLocale()

  const {
    downPayment,
    deposit,
    hasAllRiskInsurance,
    allRiskExcess,
    hasRoadAssistance,
    hasCarChecking,
    hasCarRepair,
    hasReplacementTyres,
    hasReplacementCar,
    preDeliveryCar,
    refurbishInsurance,
    homeDelivery,
    hasRoadTax,
    transferCostTag,
    manufacturerWarrantyTag,
    oficialCertifiedTag,
    takeOrReturnTag,
    guarantedFinalPriceTag,
    sellingStatus
  } = car

  return (
    <>
      <Typography variant="title3" el="h2" weight="medium">
        { sellingStatus !== 'flexible' ? t("car_data.services.title") : t("car_data.services.flexible_title")}
      </Typography>

      <List>

        {sellingStatus !== 'flexible' &&
          <>
            <Item
              value
              image="piggy-bank"
              alt={downPayment ? null : t("car_data.services-alt.no-down-payments")}
              text={
                downPayment
                  ? t("car_data.services.down-payments", { down_payment: downPayment })
                  : t("car_data.services.no-down-payments")
              }
            />
            {deposit && (
              <Item
                value
                image="final_price"
                text={deposit}
              />
            )}
            {hasAllRiskInsurance && (
              <>
                <Item
                  value
                  image="insurance"
                  alt={t("car_data.services-alt.all-risk-insurance")}
                  text={`${t("car_data.services.all-risk-insurance")} ${
                    !allRiskExcess ? t("car_data.services.franchise") : ""
                  }`}
                />
                <Item
                  value={Boolean(allRiskExcess)}
                  image="excess"
                  text={t("car_data.services.excess", { excess: allRiskExcess })}
                />
              </>
            )}
            <Item
              value={hasRoadAssistance}
              image="tow-truck"
              alt={t("car_data.services-alt.road-assistance")}
              text={t("car_data.services.road-assistance")}
            />
            <Item value={hasCarChecking} image="car-check" text={t("car_data.services.car-checking")} />
            <Item
              value={hasCarRepair}
              image="maintenance"
              alt={t("car_data.services-alt.car-repair")}
              text={t("car_data.services.car-repair")}
            />
            <Item value image="tax" alt={t("car_data.services-alt.taxes")} text={t("car_data.services.taxes")} />
            <Item
              value={hasReplacementTyres}
              image="wheel"
              alt={t("car_data.services-alt.replacement-tyres")}
              text={t("car_data.services.replacement-tyres")}
            />
          </>
        }
        {sellingStatus === 'flexible' &&
          <>
            <Item
              value
              image="piggy-bank"
              alt={downPayment ? null : t("car_data.services-alt.no-down-payments")}
              text={
                downPayment
                  ? t("car_data.services.down-payments", { down_payment: downPayment })
                  : t("car_data.services.no-down-payments")
              }
            />
            {deposit && (
              <Item
                value
                image="final-price"
                text={t("car_data.services.deposit", { deposit })}
              />
            )}
            {hasAllRiskInsurance && (
              <>
                <Item
                  value
                  image="insurance"
                  alt={t("car_data.services-alt.all-risk-insurance")}
                  text={`${t("car_data.services.all-risk-insurance")} ${
                    !allRiskExcess ? t("car_data.services.franchise") : ""
                  }`}
                />
                <Item
                  value={Boolean(allRiskExcess)}
                  image="excess"
                  text={t("car_data.services.excess", { excess: allRiskExcess })}
                />
              </>
            )}
            <Item
              value={hasRoadAssistance}
              image="tow-truck"
              alt={t("car_data.services-alt.road-assistance")}
              text={t("car_data.services.road-assistance")}
            />
            <Item value={hasCarChecking} image="car-check" text={t("car_data.services.car-checking")} />
            <Item
              value={hasCarRepair}
              image="maintenance"
              alt={t("car_data.services-alt.car-repair")}
              text={t("car_data.services.car-repair")}
            />
            <Item value image="tax" alt={t("car_data.services-alt.taxes")} text={t("car_data.services.taxes")} />
            <Item
              value={hasReplacementTyres}
              image="wheel"
              alt={t("car_data.services-alt.replacement-tyres")}
              text={t("car_data.services.replacement-tyres")}
            />
            <Item value={hasReplacementCar} image="car-key" text={t("car_data.services.replacement-car")} />
            <Item value={preDeliveryCar} image="pre-delivery" text={t("car_data.services.pre-delivery-car")} />
            <Item value={homeDelivery} image="home-delivery" text={t("car_data.services.home-delivery")} />
            <Item value={refurbishInsurance} image="car-service" text={t("car_data.services.refurbish_insurance")} />
            <Item value={transferCostTag} image="transfer_cost" text={t("car_data.services.transfer_cost_tag")} />
            <Item value={manufacturerWarrantyTag} image="warranty" text={t("car_data.services.manufacturer_warranty_tag")} />
            <Item value={oficialCertifiedTag} image="certified" text={t("car_data.services.oficial_certified_tag")} />
            <Item value={takeOrReturnTag} image="take_or_return" text={t("car_data.services.take_or_return_tag")} />
            <Item value={guarantedFinalPriceTag} image="final_price" text={t("car_data.services.guaranted_final_price_tag")} />
          </>
        }
        {locale === "it" && <Item value={hasRoadTax} image="bollo" text={t("car_data.services.road_tax")} />}
      </List>
    </>
  )
}

ServicesList.propTypes = {
  car: PropTypes.object.isRequired
}
